
import './LoginFooter.css';
import moment from 'moment';

function Footer() {
    return <div className="footer-wrapper">© Copyright {moment().format('YYYY')} by Carwiser. All rights reserved.</div>;
  }
  
export default Footer;